module.exports = __webpack_public_path__ + "static/media/film-prod-nyc-5.918c8f57.jpg";